import { gql } from '@apollo/client'
export const LOGIN_ADMIN = gql`
  mutation loginAdmin($input: LoginInput!, $recaptchaToken: String, $action: ActionInput!) {
    loginAdmin(input: $input, recaptchaToken: $recaptchaToken, action: $action) {
      userId
      loginId
      email
      username
      firstname
      lastname
      firstnameEN
      lastnameEN
      accessToken
      refreshToken
      loginDate
      expireDate
      employeeId
      employeeCode
      employeeName
      organizationId
      organizationName
      positionId
      positionName
      profilePictureId
      signatureFileId
      roles {
        add
        menuCode
        view
        edit
        delete
        send
        export
        duplicate
        approve
        process
      }
    }
  }
`
